import React from 'react';

import { WHITE } from '@wetransfer/transfer/constant/colors';

const Pointer = () => (
  <svg className="pointer" width="16px" height="7px">
    <defs>
      <path
        d="M7.49526119,1.31664646 C8.32630549,0.589482698 9.66831553,0.584776089 10.5047388,1.31664646 L17,7 L1,7 L7.49526119,1.31664646 Z"
        id="path-pointer"
      />
      <filter
        x="-50%"
        y="-50%"
        width="200%"
        height="200%"
        filterUnits="objectBoundingBox"
        id="filter-pointer"
      >
        <feOffset dx="0" dy="10" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation="15"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0"
          type="matrix"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter2" />
        <feGaussianBlur
          stdDeviation="6"
          in="shadowOffsetOuter2"
          result="shadowBlurOuter2"
        />
        <feColorMatrix
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0"
          type="matrix"
          in="shadowBlurOuter2"
          result="shadowMatrixOuter2"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="shadowMatrixOuter2" />
        </feMerge>
      </filter>
    </defs>
    <g id="pointer-shape" stroke="none" fill="none">
      <use
        fill="black"
        fillOpacity="1"
        filter="url(#filter-pointer)"
        xlinkHref="#path-pointer"
      />
      <use fill={WHITE} fillRule="evenodd" xlinkHref="#path-pointer" />
    </g>
  </svg>
);

export default Pointer;
